import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentService } from '@common/services/content.service';
import { SpjpCommunityService } from '@spjp/services/community.service';
import { SpjpCommunity } from '@spjp/model/community';

@Component({
    selector: 'app-webinar-full-registration',
    templateUrl: './webinar-full-registration.component.html',
    styleUrls: ['./webinar-full-registration.component.scss'],
    standalone: false
})
export class WebinarFullRegistrationComponent {
    public get showVideo$(): Observable<boolean> {
        return this.contentService.valueExists('webinar-youtube-video');
    }
    public get isAutoMakeProposalEnabled$(): Observable<boolean> {
        return this.communityService.autoMakeProposals$;
    }

    public get isRegistrationButtonUrlFilled$(): Observable<boolean> {
        return this.contentService.valueExists(
            'registration-webinar-registration-button-url',
        );
    }
    public get isAcceptationButtonUrlFilled$(): Observable<boolean> {
        return this.contentService.valueExists(
            'registration-webinar-acceptation-button-url',
        );
    }

    public get community$(): Observable<SpjpCommunity> {
        return this.communityService.community$;
    }

    constructor(
        public contentService: ContentService,
        public communityService: SpjpCommunityService,
    ) {}
}
